import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const ConditionsSummary = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
`;

export const SummaryText = styled.p`
    margin: 0;
    font-size: 13px;
    color: ${colors.textSecondary};
`;

export const ZoneList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Hint = styled.p`
    margin: 0;
    font-size: 12px;
    color: ${colors.textSecondary};

    a {
        color: ${colors.primary};
    }
`;
